<template>
    <div class="whatsapp-button">
        <a :href="'https://api.whatsapp.com/send?phone=' + number + '&text=' + message" target="_blank">
            <div class="container d-flex">
                <div class="message">
                    <label class="m-0">Contáctanos</label>
                </div>
                <img src="/img/wpp_icon.png" alt="WhatsApp" width="50">
            </div>
        </a>
    </div>
</template>

<script>
export default {

    props: {

        number: {
            type: String(),
            required: true,
        },

        message: {
            type: String(),
            default: String(),
        },

    },

};
</script>
